var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewIconDownloads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2928_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.125 28.5V45.125H11.875V28.5H7.125V45.125C7.125 47.7375 9.2625 49.875 11.875 49.875H45.125C47.7375 49.875 49.875 47.7375 49.875 45.125V28.5H45.125ZM30.875 30.0913L37.0263 23.9638L40.375 27.3125L28.5 39.1875L16.625 27.3125L19.9737 23.9638L26.125 30.0913V7.125H30.875V30.0913Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2928_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewIconDownloads);
export default __webpack_public_path__ + "static/media/new_icon_downloads.13f4fa098d6c2e933bfe48ba241881da.svg";
export { ForwardRef as ReactComponent };